import {CompanyStatisticsStore} from "./statistics/CompanyStatisticsStore";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.store`;
    return angular.module(moduleName, [])
                  .service(CompanyStatisticsStore.id, CompanyStatisticsStore)
                  .name;
}
